import axios from "axios";

const API = String(process.env.REACT_APP_NOT_SECRET_CODE || "").replace(/\/+$/, "");

function getToken() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && user.token;
  } catch (error) {
    return null;
  }
}

function request(method, path, data) {
  return axios({
    method,
    url: `${API}/${path}`,
    data,
    headers: {
      "Content-Type": "application/json",
      "X-Request-ID": `survey-${Date.now()}`,
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: `Bearer ${getToken() || ""}`,
    },
  }).then((response) => response.data);
}

export function getSurveys(page = 1, status = "", perPage = 15) {
  const query = [`page=${page}`, `per_page=${perPage}`];
  if (status) query.push(`status=${encodeURIComponent(status)}`);
  return request("get", `surveys?${query.join("&")}`);
}

export function getSurvey(id) {
  return request("get", `surveys/${id}`);
}

export function getSurveyOverview(id) {
  return request("get", `surveys/${id}/overview`);
}

export function createSurvey(payload) {
  return request("post", "surveys", payload);
}

export function updateSurvey(id, payload) {
  return request("patch", `surveys/${id}`, payload);
}

export function deleteSurvey(id) {
  return request("delete", `surveys/${id}`);
}

export function getSurveyTestLeads(id, page = 1, search = "", perPage = 20) {
  const query = [`page=${page}`, `per_page=${perPage}`];
  if (search) query.push(`search=${encodeURIComponent(search)}`);
  return request("get", `surveys/${id}/test-leads?${query.join("&")}`);
}

export function deploySurveyTest(id, leadIds) {
  return request("post", `surveys/${id}/test-deployments`, { leadIds });
}

export function removeSurveyTestDeployment(id, leadId) {
  return request("delete", `surveys/${id}/test-deployments/${leadId}`);
}

export function getSurveySubmissions(id, page = 1) {
  return request("get", `surveys/${id}/submissions?page=${page}`);
}

export function getSurveySubmission(surveyId, submissionId) {
  return request("get", `surveys/${surveyId}/submissions/${submissionId}`);
}


export { apiErrorMessage, paginatorFromResponse } from "./surveyApi.utils";
